/**
 * Viewer 视图模式枚举。
 */
export enum ViewMode {
    /** 三维视图模式，可自由旋转查看。 */
    VIEW_3D = '3d',
    /** 基准面视图模式，正对某个基准面进行草图编辑。 */
    DATUM_PLANE = 'datum-plane',
}
